document.addEventListener('OnVideoLoaded', (event) => {
  const node = document.getElementById('player-node').value;
  const lesson = document.getElementById('player-lesson').value;
  const session = document.getElementById('player-session').value;

  const payload = (percentageWatched, secondsWatched) => {
    return {
      activity: {
        node: node,
        lesson: lesson,
        session: session,
        percentage_watched: percentageWatched,
        seconds_watched: secondsWatched
      }
    };
  };

  const save = (payload) => {
    fetch('/activities', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector("[name='csrf-token']").content
      },
      body: JSON.stringify(payload)
    });
  };

  event.player.bind('percentwatchedchanged', (percent, lastPercent) => {
    const percentageWatched = Math.round((event.player.time() / event.player.duration()) * 100);
    const secondsWatched = Math.floor(event.player.time());
    save(payload(percentageWatched, secondsWatched));
  });
});
